import { IProps } from "config/props";
import { chatPanel } from "./chat.panel";

const panelMapping = {
  generic: [chatPanel],
};

export const getPanel = ({ id }: IProps) => {
  return panelMapping[id];
};
